import type { BookingWidgetVisualThemeId } from './types';

/** Immersive: tight geometric radii (distinct from Minimal md and Sleek lg/xl). */
const IMMERSIVE_RADIUS_TIGHT = 'rounded-[0.125rem]'; // 2px
const IMMERSIVE_RADIUS_PANEL = 'rounded-[0.25rem]'; // 4px

export type BookingWidgetCorners = {
    section: string;
    card: string;
    chip: string;
    badge: string;
    pill: string;
    input: string;
    imageTop: string;
    button: string;
    control: string;
};

export function resolveBookingWidgetCorners(
    visualTheme: BookingWidgetVisualThemeId,
): BookingWidgetCorners {
    if (visualTheme === 'immersive') {
        return {
            section: IMMERSIVE_RADIUS_PANEL,
            card: IMMERSIVE_RADIUS_PANEL,
            chip: IMMERSIVE_RADIUS_TIGHT,
            badge: IMMERSIVE_RADIUS_TIGHT,
            pill: IMMERSIVE_RADIUS_TIGHT,
            input: IMMERSIVE_RADIUS_TIGHT,
            imageTop: IMMERSIVE_RADIUS_TIGHT,
            button: IMMERSIVE_RADIUS_TIGHT,
            control: IMMERSIVE_RADIUS_TIGHT,
        };
    }

    if (visualTheme === 'minimal') {
        return {
            section: 'rounded-xl',
            card: 'rounded-lg',
            chip: 'rounded-lg',
            badge: 'rounded-full',
            pill: 'rounded-full',
            input: 'rounded-lg',
            imageTop: 'rounded-lg',
            button: 'rounded-lg',
            control: 'rounded-full',
        };
    }

    return {
        section: 'rounded-xl',
        card: 'rounded-lg',
        chip: 'rounded-lg',
        badge: 'rounded-full',
        pill: 'rounded-full',
        input: 'rounded-md',
        imageTop: 'rounded-t-lg',
        button: 'rounded-md',
        control: 'rounded-full',
    };
}
